export default import.meta.ROLLDOWN_FILE_URL_32VkJviA7$UfR5MHZzmKSg